// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { ElementOperand, ElementOperandT } from "./element-operand";
import { LiteralOperand, LiteralOperandT } from "./literal-operand";
import { SimpleAttributeOperand, SimpleAttributeOperandT } from "./simple-attribute-operand";

/**
 * Operand of a content-filter element.
 */
export enum FilterOperand {
  NONE = 0,
  LiteralOperand = 1,
  SimpleAttributeOperand = 2,
  ElementOperand = 3,
}

export function unionToFilterOperand(
  type: FilterOperand,
  accessor: (
    obj: ElementOperand | LiteralOperand | SimpleAttributeOperand,
  ) => ElementOperand | LiteralOperand | SimpleAttributeOperand | null,
): ElementOperand | LiteralOperand | SimpleAttributeOperand | null {
  switch (FilterOperand[type]) {
    case "NONE":
      return null;
    case "LiteralOperand":
      return accessor(new LiteralOperand())! as LiteralOperand;
    case "SimpleAttributeOperand":
      return accessor(new SimpleAttributeOperand())! as SimpleAttributeOperand;
    case "ElementOperand":
      return accessor(new ElementOperand())! as ElementOperand;
    default:
      return null;
  }
}

export function unionListToFilterOperand(
  type: FilterOperand,
  accessor: (
    index: number,
    obj: ElementOperand | LiteralOperand | SimpleAttributeOperand,
  ) => ElementOperand | LiteralOperand | SimpleAttributeOperand | null,
  index: number,
): ElementOperand | LiteralOperand | SimpleAttributeOperand | null {
  switch (FilterOperand[type]) {
    case "NONE":
      return null;
    case "LiteralOperand":
      return accessor(index, new LiteralOperand())! as LiteralOperand;
    case "SimpleAttributeOperand":
      return accessor(index, new SimpleAttributeOperand())! as SimpleAttributeOperand;
    case "ElementOperand":
      return accessor(index, new ElementOperand())! as ElementOperand;
    default:
      return null;
  }
}

export type FilterOperandT =
  | { type: "NONE"; value: null }
  | { type: "LiteralOperand"; value: LiteralOperandT }
  | { type: "SimpleAttributeOperand"; value: SimpleAttributeOperandT }
  | { type: "ElementOperand"; value: ElementOperandT };
